import { supabase } from '../supabase';

/**
 * Legge la propria registration_session tramite il session_token (un bearer
 * secret UNIQUE generato server-side, non enumerabile).
 *
 * SICUREZZA: usa la RPC SECURITY DEFINER `get_registration_session_by_token`, che
 * applica il filtro per-token lato server. Sostituisce il vecchio
 * `supabase.from('registration_sessions').select(...).eq('session_token', ...)`,
 * dove il filtro era solo client-side e — con la policy anon `USING(true)` — un
 * anon poteva togliere il filtro e dumpare la PII di tutte le sessioni.
 *
 * Fallback: finché la RPC non è deployata in produzione (finestra tra lo step 1
 * della migration e il deploy frontend), la funzione ricade sul SELECT diretto
 * legacy. Dopo lo step 2 della migration (REVOKE) il fallback non è più
 * raggiungibile perché la RPC esiste sempre e viene tentata per prima.
 */
export async function getRegistrationSessionByToken(sessionToken: string) {
  const rpc = await supabase
    .rpc('get_registration_session_by_token', { p_token: sessionToken })
    .maybeSingle();

  // PGRST202 = funzione non trovata (RPC non ancora applicata): fallback legacy.
  const fnMissing =
    rpc.error &&
    (rpc.error.code === 'PGRST202' ||
      /function|does not exist|not found/i.test(rpc.error.message ?? ''));

  if (fnMissing) {
    return supabase
      .from('registration_sessions')
      .select('*')
      .eq('session_token', sessionToken)
      .maybeSingle();
  }

  return rpc;
}
